import React from 'react';

import {
  DetailsBlock as BaseDetailsBlock,
  DetailsColumn,
} from '@Calix-Commerce/design-system/components';

import { NOT_APPLICABLE_LABEL } from 'utils/constants';
import { useFormatPrice } from 'utils/hooks';
import { formatDate } from 'utils/helpers/date';

const DetailsBlock = ({ orderData = {} }) => {
  const formatPrice = useFormatPrice();
  const billingData = orderData.billingInfo || {};

  return (
    <BaseDetailsBlock>
      <DetailsColumn>
        <span>SO #: {orderData.salesOrderNumber || NOT_APPLICABLE_LABEL}</span>
        <span>PO #: {billingData.purchaseOrderNumber || NOT_APPLICABLE_LABEL}</span>
        <span>Ordered By: {billingData.orderedByContactName}</span>
        <span>Order Date: {formatDate(orderData.fiscalOrderDate)}</span>
        <span>Order Currency: {orderData.currencyCode}</span>
      </DetailsColumn>
      <DetailsColumn alignRight>
        <span>Total: {formatPrice(orderData.orderValue)}</span>
        <span>Status: {orderData.orderStatus}</span>
        <span>Quote Name: {orderData.quoteName || NOT_APPLICABLE_LABEL}</span>
        <span>Order Type: {orderData.orderType}</span>
      </DetailsColumn>
    </BaseDetailsBlock>
  );
};

export { DetailsBlock };
